export default __webpack_public_path__ + "static/media/39.cf8b2922.jpeg";